export default {
  // dict(data,r){
  //   data.dict=r
  // }
}
